import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Pain.module.css';
import { DBCheckBox, DBDropDown, DBRadioButton } from '_components';
import { isPanelOnNote } from '_helpers';


class PatientCareCenterNoteSubjectivePain extends React.Component {


    renderRatingScale(left, right, col) {
        let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        return (
            <div className={styles.psq_range_wrapper}>
                <div className={styles.psq_range_row}>
                    <div className={styles.psq_range_left}>{left}</div>
                    <div className={styles.psq_range_right}>{right}</div>
                </div>
                <div className={styles.psq_answer_row}>
                    {arr.map(element => {
                        return (
                            <div key={element} className={styles.psq_10_col}>
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='CWPAINSCREENING'
                                    entityKeyColumn='PSQNO'
                                    entityKeyValue={this.props.psqno}
                                    field={col}
                                    label={element}
                                    selectedValue={element}
                                />
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
    renderRadioRow(col, arr) {
        return (
            <div className={styles.psq_answer_row}>
                {arr.map(element => {
                    return (
                        <div key={element[0]} className={styles.psq_5_col}>
                            <DBRadioButton
                                noteId={this.props.noteId}
                                entity='CWPAINSCREENING'
                                entityKeyColumn='PSQNO'
                                entityKeyValue={this.props.psqno}
                                field={col}
                                label={element[0]}
                                selectedValue={element[1]}
                            />
                        </div>
                    )
                })}
            </div>
        );
    }


    renderBodyPartRow(col1, label1, col2, label2) {
        return (
            <div className={styles.psq_answer_row}>
                <div className={styles.psq_5_col}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='CWPAINSCREENING'
                        entityKeyColumn='PSQNO'
                        entityKeyValue={this.props.psqno}
                        field={'PSQPAIN' + col1}
                        label={label1}
                    />
                </div>
                <div className={styles.psq_5_col} />
                <div className={styles.psq_5_col}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='CWPAINSCREENING'
                        entityKeyColumn='PSQNO'
                        entityKeyValue={this.props.psqno}
                        field={'PSQPAIN' + col2}
                        label={label2}
                    />
                </div>
                <div className={styles.psq_5_col} />
                <div className={styles.psq_5_col} />
            </div>
        );
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_pain' name='Pain Rating' level={1}>
                <div className={styles.rating_row}>
                    <label className={(this.props.isWc || this.props.isPainRequired) ? styles.rating_label_req : styles.rating_label}>Current:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPAINCURRENT'
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />
                    <label className={styles.rating_label}>Best:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPAINBEST'
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />
                    <label className={styles.rating_label}>Worst:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPAINWORST'
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />
                </div>

                {this.props.psqno &&
                    <PatientCareCenterNoteSection id='subj_pain_psq' name='Pain Screening Questionnaire' level={2} className={styles.required} allowCollapse={false}>
                        <div className={styles.psq_section_header}>
                            These questions and statements apply if you have aches or pains such as back,
                            shoulder or neck pain.  Please read and answer each question carefully.  Do
                            not take too long to answer each question.  However, it is important that
                            you answer every question.  Each question should always have an answer.
                        </div>
                        <div className={styles.psq_question}>
                            What level of school did you complete?
                        </div>
                        {this.renderRadioRow('PSQEDUCATION', [
                            ['Did not graduate', 'Did not graduate'],
                            ['GED/High School', 'GED/High School'],
                            ['Some College', 'Some College'],
                            ['Graduated College', 'Graduated College'],
                            ['Beyond', 'Beyond']
                        ])}

                        <div className={styles.psq_question}>
                            The physical demands of your job are:
                        </div>

                        {this.renderRadioRow('PSQPDC', [
                            ['Sedentary', 'Sedentary'],
                            ['Light', 'Light'],
                            ['Medium', 'Medium'],
                            ['Heavy', 'Heavy']
                        ])}

                        <div className={styles.psq_question}>
                            Where do you have pain?  (Check all that apply)
                        </div>
                        {this.renderBodyPartRow('HEAD', 'Head', 'TRUNK', 'Trunk')}
                        {this.renderBodyPartRow('FACE', 'Face', 'ABDOMEN', 'Abdomen')}
                        {this.renderBodyPartRow('NECK', 'Neck', 'LOWBACK', 'Low Back')}
                        {this.renderBodyPartRow('SHOULDERS', 'Shoulder(s)', 'HIPS', 'Hip(s)')}
                        {this.renderBodyPartRow('CHEST', 'Chest', 'GROIN', 'Groin')}
                        {this.renderBodyPartRow('ARMS', 'Arm(s)', 'KNEES', 'Knee(s)')}
                        {this.renderBodyPartRow('WRISTS', 'Wrist(s)', 'ANKLE', 'Ankle(s)')}
                        {this.renderBodyPartRow('HANDS', 'Hand(s)', 'FOOT', 'Feet')}

                        <div className={styles.psq_question}>
                            How many days of work have you missed because of pain in the past 18 months?
                        </div>
                        {this.renderRadioRow('PSQDAYSMISSED', [
                            ['0 days', 1],
                            ['1-2 days', 2],
                            ['3-7 days', 3],
                            ['8-14 days', 4],
                            ['15-30 days', 5]
                        ])}
                        {this.renderRadioRow('PSQDAYSMISSED', [
                            ['1 month', 6],
                            ['2 months', 7],
                            ['3-6 months', 8],
                            ['6-12 months', 9],
                            ['Over 1 year', 10]
                        ])}

                        <div id='psq_pain_duration' className={styles.psq_question}>
                            How long have you had your current pain problem?
                        </div>
                        {this.renderRadioRow('PSQPAINDURATION', [
                            ['0 days', 1],
                            ['1-2 days', 2],
                            ['3-7 days', 3],
                            ['8-14 days', 4],
                            ['15-30 days', 5]
                        ])}
                        {this.renderRadioRow('PSQPAINDURATION', [
                            ['1 month', 6],
                            ['2 months', 7],
                            ['3-6 months', 8],
                            ['6-12 months', 9],
                            ['Over 1 year', 10]
                        ])}

                        <div className={styles.psq_question}>
                            Is your work heavy or monotonous?
                        </div>
                        {this.renderRatingScale('Not at all monotonous', 'Extremely monotonous', 'PSQRATEWORKHEAVY')}

                        <div className={styles.psq_question}>
                            How would you rate the pain you have had during the past week?
                        </div>
                        {this.renderRatingScale('No pain', 'Pain as bad as it can be', 'PSQRATEPAINWEEK')}

                        <div className={styles.psq_question}>
                            In the past 3 months (on average) how bad was your pain?
                        </div>
                        {this.renderRatingScale('No pain', 'Pain as bad as it can be', 'PSQRATEPAIN3MONTH')}

                        <div className={styles.psq_question}>
                            How often would you say you have experienced pain episodes, on average, during the past 3 months?
                        </div>
                        {this.renderRatingScale('Never', 'Always', 'PSQPAINOCCURENCES3MONTH')}

                        <div className={styles.psq_question}>
                            Based on all the things you do to cope with your pain, on an average day, how much are you able to decrease it?
                        </div>
                        {this.renderRatingScale('Can\'t decrease', 'Can decrease it completely', 'PSQRATECOPETODECREASE')}

                        <div className={styles.psq_question}>
                            How tense or anxious have you flet in the past week?
                        </div>
                        {this.renderRatingScale('Absolutely calm and relaxed', 'As tense as I\'v ever been', 'PSQRATETENSION')}

                        <div className={styles.psq_question}>
                            How much have you been bothered by feeling depressed in the past week?
                        </div>
                        {this.renderRatingScale('Not at all bothered', 'Extremely bothered', 'PSQRATEDEPRESSION')}

                        <div className={styles.psq_question}>
                            In your view, how large is the risk that your current pain may become permanent?
                        </div>
                        {this.renderRatingScale('No risk', 'Very large risk', 'PSQRATEPERMANENT')}

                        <div className={styles.psq_question}>
                            In your estimation, what are the chances you will be working in 6 months?
                        </div>
                        {this.renderRatingScale('No chance', 'Very large chance', 'PSQRATEBACKTOWORK')}

                        <div className={styles.psq_question}>
                            If you take into consideration your work routines, management, salary, promotion possibilities
                            and co-workers, how satisfied are you with your job?
                        </div>
                        {this.renderRatingScale('Not at all satisfied', 'Extremely satisfied', 'PSQRATEJOBSATISFACTION')}

                        <div className={styles.psq_section_header}>
                            Here are some things people have told us about their pain.  For each statement select one number
                            from 1 to 10 that indicates how much physical activities affect your pain.
                        </div>
                        <div className={styles.psq_question}>
                            Physical activities make my pain worse.
                        </div>
                        {this.renderRatingScale('Completely disagree', 'Completely agree', 'PSQPHYSICALPAINWORSE')}

                        <div className={styles.psq_question}>
                            An increase in pain is an indication that I should stop what I'm doing until the pain decreases.
                        </div>
                        {this.renderRatingScale('Completely disagree', 'Completely agree', 'PSQPAINSTOPACTIVITY')}

                        <div className={styles.psq_question}>
                            I should not do my normal work with my present pain.
                        </div>
                        {this.renderRatingScale('Completely disagree', 'Completely agree', 'PSQNOTWORKWITHPAIN')}

                        <div className={styles.psq_section_header}>
                            Here is a list of five activities.  Please indicate the number that best describes your current
                            ability to participate in each of these activities.
                        </div>
                        <div className={styles.psq_question}>
                            I can do light work for an hour.
                        </div>
                        {this.renderRatingScale('Can\'t do it because of pain problem', 'Can do it without pain being a problem', 'PSQLIGHTWORK1HR')}

                        <div className={styles.psq_question}>
                            I can walk for an hour.
                        </div>
                        {this.renderRatingScale('Can\'t do it because of pain problem', 'Can do it without pain being a problem', 'PSQWALK1HR')}

                        <div className={styles.psq_question}>
                            I can do ordinary household chores.
                        </div>
                        {this.renderRatingScale('Can\'t do it because of pain problem', 'Can do it without pain being a problem', 'PSQHOUSEHOLD')}

                        <div className={styles.psq_question}>
                            I can go shopping.
                        </div>
                        {this.renderRatingScale('Can\'t do it because of pain problem', 'Can do it without pain being a problem', 'PSQSHOPPING')}

                        <div className={styles.psq_question}>
                            I can sleep at night.
                        </div>
                        {this.renderRatingScale('Can\'t do it because of pain problem', 'Can do it without pain being a problem', 'PSQSLEEP')}


                    </PatientCareCenterNoteSection>
                }
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let evno = parseInt(noteId.split("_")[1]);
    let key = Object.keys(state.entities.notes.CWPAINSCREENING).find(x => state.entities.notes.CWPAINSCREENING[x].PSQEVNO === evno);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isWc = state.entities.admissions[epno].isWc;
    let isPainRequired = state.entities.admissions[epno].isPainRequired;
    let psqno = undefined;
    if (key !== undefined) {
        psqno = state.entities.notes.CWPAINSCREENING[key].PSQNO;
    }

    return {
        noteId,
        isWc,
        evno,
        psqno,
        isPainRequired
    };
}
const connectedPatientCareCenterNoteSubjectivePain = connect(mapStateToProps)(PatientCareCenterNoteSubjectivePain);
export { connectedPatientCareCenterNoteSubjectivePain as PatientCareCenterNoteSubjectivePain };

